import { SET_TAB } from './mutations.type';

export default {
  [SET_TAB](state, tab) {
    state.tab = tab;
  },
};
